"use client";

import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { Message, MessageContent } from "@/components/ai-elements/message";
import { ActivityProgressStatusRow } from "./activity-live-status";
import { ActivityWorkingTime } from "./activity-working-time";

/** submitted 中に assistant message がまだ無い時間を明示する。 */
export function PendingResponseRow({ startedAtMs }: { startedAtMs: number }) {
  const { i18n } = useLingui();
  return (
    <Message
      className="min-h-[max(12rem,calc(100cqh-16rem))]"
      data-chat-message-row="pending-response"
      data-testid="pending-response-row"
      from="assistant"
    >
      <MessageContent className="w-full max-w-full" variant="flat">
        <div className="w-full space-y-2">
          <ActivityWorkingTime
            elapsedBeforeCurrentSegmentMs={0}
            startedAtMs={startedAtMs}
          />
          <ActivityProgressStatusRow label={i18n._(msg`Thinking...`)} />
        </div>
      </MessageContent>
    </Message>
  );
}
